import "./assets/main.css";
import "@nsftx/seven-client-sdk-admin/admin-ui";
import "@nsftx/seven-nxg-design-system-backoffice/style";

import { createApp } from "vue";
import FloatingVue from "floating-vue";

import App from "./App.vue";

import { registerPlugins } from "@/plugins";
import { initializeKeyloak } from "@/services/auth.js";
import { getTranslations } from "./services/api/translations";
import { setTranslations } from "./services/i18n";

BigInt.prototype.toJSON = () => this.toString();

(async () => {
  try {
    const translations = await getTranslations("", "en");
    setTranslations(translations);
  } catch {}

  await initializeKeyloak();

  const app = createApp(App);
  registerPlugins(app);

  app.use(FloatingVue);
  app.mount("#app");
})();
